module.exports = __webpack_public_path__ + "img/Slide48.20054da8.png";